var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playerWrapper"},[_c('iframe',{class:{ hiddenPlayer: _vm.currentTrack == _vm.initTrack },attrs:{"id":'main',"width":"100px","height":"200px","scrolling":"no","frameborder":"no","allow":"autoplay","src":_vm.playerUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }